import { AppState } from '../index';
import { IToastOptions } from '../../core/models';

export const isToastOpenSelector = ({ toast }: AppState): boolean => toast?.toastOpen;
export const toastOptionsSelector = ({ toast }: AppState): IToastOptions => toast?.toastOptions;
